import Image from "next/image";
import { useRouter } from "next/router";
import React, { useContext } from "react";
import { LocalizationContext } from "src/lib/context";

const CompareDroner = ({
  profImage,
  username,
  contactEmail,
  tel,
}: {
  profImage: string;
  username: string;
  contactEmail: string;
  tel: number;
}) => {
  const { profilePage } = useContext(LocalizationContext).localeStrings;
  const router = useRouter();

  return (
    <div className="compare__droner">
      <Image
        src={profImage ?? "/assets/profile_placeholder.svg"}
        alt=""
        width="100"
        height="100"
        onClick={() => router.push(`/droners/${username}`)}
      />
      <h3
        className="compare__primaryText"
        onClick={() => router.push(`/droners/${username}`)}
        children={username}
      />
      <div>
        <h5 className="body-2">{contactEmail}</h5>
        <h5 className="body-2">
          {tel ? `+${tel}` : profilePage.noPhoneNumber}
        </h5>
      </div>
    </div>
  );
};

export default CompareDroner;
